var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiMostardaSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0717,
    cy: 10.9672,
    r: 10.2201,
    fill: "#FE9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.294 16.1327C15.5398 16.1807 15.7781 16.0203 15.8261 15.7744C15.8741 15.5285 15.7137 15.2903 15.4678 15.2423L15.294 16.1327ZM6.68087 15.1732C6.43445 15.2184 6.27133 15.4548 6.31654 15.7012C6.36174 15.9477 6.59815 16.1108 6.84456 16.0656L6.68087 15.1732ZM15.4678 15.2423C13.6499 14.8874 12.3322 14.7048 11.0224 14.696C9.71217 14.6872 8.42901 14.8525 6.68087 15.1732L6.84456 16.0656C8.57266 15.7486 9.79059 15.595 11.0163 15.6032C12.2426 15.6115 13.4959 15.7817 15.294 16.1327L15.4678 15.2423Z",
    fill: "#FBFFFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.25597,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2814,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiMostardaSlider);
export default __webpack_public_path__ + "static/media/emojiMostardaSlider.12db11ddad2a30c8a3acfac348ccc502.svg";
export { ForwardRef as ReactComponent };